import { z } from 'zod';

const corporateActionDateSchema = z.iso.datetime({ offset: true });

export const corporateActionSchema = z.object({
  id: z.string().uuid(),
  provider_event_id: z.string(),
  entity_tag: z.string(),
  action_type: z.string(),
  status: z.string().optional(),
  announced_date: corporateActionDateSchema.optional(),
  effective_date: corporateActionDateSchema,
  record_date: corporateActionDateSchema.optional(),
  expiry_date: corporateActionDateSchema.optional(),
  num_new_shares: z.number().optional(),
  num_old_shares: z.number().optional(),
  cash_amount: z.number().optional(),
  currency: z.string().optional(),
  offer_company_name: z.string().optional(),
});

export type CorporateAction = z.infer<typeof corporateActionSchema>;
